export default __webpack_public_path__ + "static/media/science-icon.7c59ce75.webp";